import React, { useState } from "react";
import AdminUserCommentsrow from "./AdminUserCommentsrow";
import filterIcon from "../../../../assets/img/admin/setting-4.svg";
import sortIcon from "../../../../assets/img/admin/sort.svg";
import Button from "../../../shared/Button";
import useFetch from "../../../../hooks/useAxios";
const AdminUsersComments = () => {
  const [activeid, setactiveid] = useState(1);
  const [CommentList, setCommentList] = useState([]);
  const apiCommentList = useFetch({
    method: "get",
    url: "api/admin/comments",
    noHeader: false,
    trigger: true,
    argFunc: res => setCommentList(res.data.all_comments)
  });
  return (
    <div>
      <h2 className="text-[36px] font-[700] text-[#12171C]">
        لیست دیدگاه کاربران
      </h2>
      <div className="flex justify-between items-center mt-[32px] mb-[40px]">
        <div className="flex gap-[36px]">
          <button
            className={`text-[15px] font-[500] ${activeid === 1
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
            همه دیدگاه ها
          </button>
          <button
            className={`text-[15px] font-[500] ${activeid === 2
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
            دیدگاه های تایید نشده
          </button>
          <button
            className={`text-[15px] font-[500] ${activeid === 3
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
            دیدگاه های تایید شده
          </button>
        </div>
        <div className="flex gap-[16px]">
            <Button varient="outline-gray">
                <div className="flex gap-[5px]">
                    <img src={filterIcon}/>
                    <p>فیلتر</p>

                </div>
            </Button>
            <Button className="button__gray ">
                <div className="flex gap-[5px]">
                    <img src={sortIcon}/>
                    <p>مرتب سازی</p>

                </div>
            </Button>
        </div>
      </div>

      <div>
      { CommentList.map(i=><AdminUserCommentsrow info={i} />)}
       
      </div>
    </div>
  );
};

export default AdminUsersComments;
